import NewsletterThirtyTwoContainer from "./container/NewsletterThirtyTwoContainer";
export default NewsletterThirtyTwoContainer;
